import { useSearchParams, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function UnsubscribeConfirm() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const subscriberId = searchParams.get("id");

  const handleUnsubscribe = () => {
    if (!subscriberId) {
      navigate("/");
      return;
    }

    // Get the Supabase function URL
    const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
    const unsubscribeUrl = `${supabaseUrl}/functions/v1/unsubscribe?id=${subscriberId}&confirm=true`;

    // Redirect to the edge function with confirm=true
    window.location.href = unsubscribeUrl;
  };

  const handleKeepSubscription = () => {
    navigate("/");
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-background via-background to-secondary/20 flex items-center justify-center p-4">
      <div className="bg-card border border-border rounded-lg shadow-lg p-8 max-w-md w-full text-center">
        <h1 className="text-2xl font-bold mb-4 font-serif">Unsubscribe from 21-Day AI Challenge?</h1>
        <p className="text-muted-foreground mb-8">
          Are you sure you want to stop receiving daily emails from the 21-Day AI Challenge?
          You can always resubscribe later.
        </p>

        <div className="flex flex-col gap-3">
          <Button
            onClick={handleUnsubscribe}
            variant="destructive"
            className="w-full"
          >
            Yes, Unsubscribe
          </Button>
          <Button
            onClick={handleKeepSubscription}
            variant="outline"
            className="w-full"
          >
            Keep My Subscription
          </Button>
        </div>
      </div>
    </div>
  );
}
